/**
 * "[Name] needs their grade before you can order" — the order-blocking
 * student-setup banner, shown while any student has campus-REQUIRED facts
 * missing or an unconfirmed campus. Shared by /family and /orders/family so
 * every surface a parent lands on says the same thing (PROD-385 follow-up:
 * the weekly Orders page had lost it in the rebuild); the CTA opens
 * `CompleteStudentInfoSheet`.
 */

import { Button } from '@ordo/ui/button'

import { missingRequiredInfoMessage, type StudentNeedingInfo } from '@/api/family'

export function MissingInfoBanner({
  students,
  onFinishSetup,
}: {
  students: StudentNeedingInfo[]
  onFinishSetup: () => void
}) {
  const message = missingRequiredInfoMessage(students)
  if (!message) {
    return null
  }
  return (
    <div
      data-testid="missing-info-banner"
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-300/60 bg-amber-50 px-4 py-3 dark:border-amber-500/40 dark:bg-amber-950/30">
      <p className="text-sm font-medium text-foreground">{message}</p>
      <Button variant="default" size="sm" onClick={onFinishSetup}>
        Finish setup
      </Button>
    </div>
  )
}
